import { render, staticRenderFns } from "./WrappingSvg.vue?vue&type=template&id=789059c8&"
import script from "./WrappingSvg.vue?vue&type=script&lang=js&"
export * from "./WrappingSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports